import { endOfISOWeek, startOfISOWeek } from "date-fns";
import { TFunction } from "i18next";
import * as Yup from "yup";

import { ExchangeableAppointmentResponse } from "@/api";
import { exchangeAppointmentSelectionRules } from "@/pages/exchange/Exchange.utils";

import { MakeOfferFormValues } from "./MakeOfferDialog.types";

/** Monday to Sunday of the week containing `today` — the dialog's preset date range. */
export function currentWeekRange(today: Date = new Date()): Pick<MakeOfferFormValues, "from" | "till"> {
  return { from: startOfISOWeek(today), till: endOfISOWeek(today) };
}

export function filterByRequestedPurposes(
  appointments: ExchangeableAppointmentResponse[],
  requestedPurposeKeys: string[],
  enabled: boolean
): ExchangeableAppointmentResponse[] {
  if (!enabled) {
    return appointments;
  }
  return appointments.filter((appointment) => requestedPurposeKeys.includes(appointment.purposeKey));
}

export function makeOfferValidationSchema(t: TFunction): Yup.ObjectSchema<MakeOfferFormValues> {
  return Yup.object({
    ...exchangeAppointmentSelectionRules(t, t("exchange.offerDialog.from"), t("exchange.offerDialog.till")),
    onlyRequestedPurposes: Yup.boolean().required(),
    // Formik hands an empty text field to Yup as undefined, so the note needs a default to stay optional.
    note: Yup.string().default(""),
  });
}
